var map = {
	"./calendar.webp": 1512,
	"./cash.webp": 1513,
	"./check-in-title-bg.webp": 1514,
	"./coin.webp": 1515,
	"./current-check-in-container.webp": 1516,
	"./current-last-day-check-in-container.webp": 1517,
	"./daily-check-in-bg.webp": 1518,
	"./default-check-in-container.webp": 1519,
	"./giftbox.webp": 1520,
	"./golden-coin.webp": 1521,
	"./halfweek-check-in-container.webp": 1522,
	"./last-day-check-in-container.webp": 1523,
	"./missed-checkIn.webp": 1524,
	"./more-cash.webp": 1525,
	"./more-coin.webp": 1526,
	"./more-spin.webp": 1527,
	"./need-deposit.webp": 1528,
	"./present.webp": 1529,
	"./reward-coin.webp": 1530,
	"./shine.webp": 1531,
	"./silver-coin.webp": 1532,
	"./spin.webp": 1533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;